export default "__VITE_ASSET__SfrnScJt__"